import React from 'react'
import { StatusBadge } from '@/components/ui/StatusBadge'
import type { MrpIssueCode } from '../types/mrpTypes'
import { formatIssueInfo } from '../utils/mrpFormatters'

export interface MrpIssueBadgeProps {
  issues?: MrpIssueCode[]
  className?: string
}

export function MrpIssueBadge({ issues = [], className = '' }: MrpIssueBadgeProps): React.ReactElement | null {
  if (!issues || issues.length === 0) return null

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {issues.map((code) => {
        const info = formatIssueInfo(code)
        return (
          <StatusBadge
            key={code}
            tone={info.tone}
            label={info.label}
            showDot
          />
        )
      })}
    </div>
  )
}
